import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import cx from 'classnames';
import Sidebar from './Sidebar';
import Copyright from './Copyright';
import useRefreshAuth from '../../core/EcrionProvider/useRefreshAuth';
import capitalize from '../../utils/formatting/capitalize';
import { usePageContext } from '../../page/Provider';
import withThemeProps from '../../theme/withThemeProps';
/**
 * @param {import('./types').PageCommonProps & import('@material-ui/core').WithStyles<typeof styles, true>} props
 */

var CommonPage = function CommonPage(_ref) {
  var classes = _ref.classes,
      theme = _ref.theme,
      children = _ref.children,
      sidebar = _ref.sidebar,
      margin = _ref.margin,
      copyright = _ref.copyright,
      reloadBackendInfo = _ref.reloadBackendInfo,
      style = _ref.style;

  var _React$useState = React.useState(sidebar && sidebar.variant === 'properties' ? true : false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sidebarOpened = _React$useState2[0],
      toggleSidebar = _React$useState2[1];

  var _usePageContext = usePageContext(),
      navBar = _usePageContext.navBar,
      toolBar = _usePageContext.toolBar,
      insertion = _usePageContext.insertion;

  var sidebarPosition;
  var sidebarVariant;
  var onChangeSidebarPanel;

  if (sidebar) {
    onChangeSidebarPanel = function onChangeSidebarPanel(option, e) {
      if (option.value === sidebar.value) {
        //clicked on the same panel, trigger toggle
        toggleSidebar(!sidebarOpened);
      } else {
        if (sidebar.onChange) return sidebar.onChange(option, e);
      }
    };

    if (sidebar.variant) sidebarVariant = sidebar.variant;else sidebarVariant = 'filter';

    if (sidebar.position) {
      sidebarPosition = sidebar.position;
    } else {
      if (sidebarVariant === 'filter') sidebarPosition = 'left';else if (sidebarVariant === 'property') sidebarPosition = 'right';else if (sidebarVariant === 'properties') sidebarPosition = 'left';
    }
  }

  var sidebarThemeStyle = theme.getStyle('Page.SideBar');
  var navBarThemeStyle = theme.getStyle('Page.NavBar');
  var sidebarStyle = {
    top: 0
  };

  var wrapperStyle = _objectSpread({}, style, {
    left: 0,
    right: 0
  });

  var insertionStyle = {
    top: 0,
    bottom: 0,
    right: 0,
    width: 0
  };
  if (navBar) sidebarStyle.top += navBarThemeStyle.height;
  if (toolBar) sidebarStyle.top += theme.getStyle('Page.ToolBar').height;
  wrapperStyle.top = sidebarStyle.top;

  if (sidebar) {
    if (sidebarVariant === 'property' && sidebarPosition === 'right') {
      // @ts-ignore
      wrapperStyle.right = sidebarThemeStyle.propertyWidth;
      wrapperStyle.left = 0;
      sidebarStyle.right = 0;
    } else if (sidebarVariant === 'property' && sidebarPosition === 'left') {
      // @ts-ignore
      wrapperStyle.left = sidebar.width || sidebarThemeStyle.propertyWidth;
      sidebarStyle.left = 0;
    } else if (sidebarVariant === 'properties' && sidebarPosition === 'left') {
      wrapperStyle.left = sidebarOpened ? sidebarThemeStyle.collapsedWidth + sidebarThemeStyle.propertiesWidth : sidebarThemeStyle.collapsedWidth;
      sidebarStyle.left = 0;
    } else if (sidebarVariant === 'filter' && sidebarPosition === 'left') {
      wrapperStyle.left = sidebarOpened ? sidebarThemeStyle.filterWidth : sidebarThemeStyle.collapsedWidth;
      sidebarStyle.left = 0;
    }
  }

  if (insertion) {
    wrapperStyle.right = insertion.width;
    insertionStyle.width = insertion.width;
    insertionStyle.top = sidebarStyle.top;
  }

  var sidebarEl = sidebar ? React.createElement(Sidebar, Object.assign({}, sidebar, {
    open: sidebarOpened,
    onChange: onChangeSidebarPanel,
    toggle: toggleSidebar,
    variant: sidebarVariant,
    position: sidebarPosition,
    width: sidebar && sidebar.width,
    wrapperStyle: sidebarStyle
  })) : null;
  if (reloadBackendInfo) useRefreshAuth();
  return React.createElement(React.Fragment, null, sidebar && sidebarEl, React.createElement("div", {
    className: classes.wrapper,
    style: wrapperStyle
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    className: classes.grid
  }, React.createElement(Grid, {
    style: {
      position: 'relative'
    },
    item: true,
    xs: true,
    className: cx(_defineProperty({}, classes["margin".concat(capitalize(margin))], margin !== 'none'))
  }, children), React.createElement(Grid, {
    item: true
  }, copyright && React.createElement(Copyright, null)))), insertion && React.createElement("div", {
    className: classes.insertion,
    style: insertionStyle
  }, insertion.children));
};

var styles = function styles(theme) {
  return createStyles({
    wrapper: {
      position: 'fixed',
      bottom: 0,
      top: 0,
      overflowY: 'auto',
      maxWidth: '100%',
      backgroundColor: 'inherit'
    },
    grid: {
      minHeight: '100%'
    },
    marginNormal: {
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 24,
      paddingRight: 24
    },
    marginDense: {
      padding: 12
    },
    insertion: {
      position: 'fixed'
    }
  });
};

CommonPage.defaultProps = {
  margin: 'normal',
  reloadBackendInfo: false,
  copyright: false
};
export default withThemeProps('Page.Common', {
  withTheme: true
})(withStyles(styles, {
  name: 'ECCommonPage'
})(CommonPage));